import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "customer-home",
      path: "",
      props: true,
      meta: {
        icon: "dashboard",
        title: i18n.global.t("Dashboard"),
      },
      component: () => import("pages/customer/Home"),
    },
    {
      name: "customer-notifications",
      path: "notifications/:page?",
      props: true,
      meta: {
        icon: "notification",
        title: i18n.global.tc("Notification", 100),
      },
      component: () => import("pages/Notifications"),
    },
    {
      name: "customer-reminders",
      path: "reminders/:page?",
      props: true,
      meta: {
        icon: "snooze",
        title: i18n.global.tc("Reminder", 100),
      },
      component: () => import("pages/Notifications"),
    },
    {
      name: "customer-account",
      path: "account",
      props: true,
      meta: {
        icon: "accounting",
        title: i18n.global.t("Account"),
        widget: "CustomerAccount",
      },
      component: () => import("pages/customer/Home"),
    },
    {
      name: "customer-company-admin",
      path: "company-admin",
      props: true,
      meta: {
        icon: "admin",
        title: i18n.global.t("portal.companyAdmin"),
        auth: ({ customerID }) =>
          store.getters.isCompanyAdmin(customerID) ||
          store.getters.isEmployee(),
        widget: "CustomerCompanyMembers",
      },
      component: () => import("pages/customer/Home"),
    },
  ],

  dialogs: [],
};
